import { render, staticRenderFns } from "./NTable.vue?vue&type=template&id=452003ba&scoped=true&"
import script from "./NTable.vue?vue&type=script&lang=js&"
export * from "./NTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452003ba",
  null
  
)

export default component.exports